import {Component, OnInit, OnDestroy} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {TabLabel} from '../../../../common/types';
import {TabSelectionService} from '../../../../common/services/tab-selection.service';
import {GenericImageDialogComponent} from '../../../../common/dialogs/generic-image-dialog/generic-image-dialog.component';
import {UserAuthorisationService} from 'src/app/modules/common/services/user-authorisation.service';
import {EnvironmentService} from '../../../../common/services/environment-service';
import {ClaimRoutesQueryParam as QueryParam} from '../../../../common/types/routes-query-param.enum';

enum Tab {
  Case,
  Claim,
  Payment
}

const TabQueryParamByIndexNo = {
  [Tab.Case]: QueryParam.Cases,
  [Tab.Claim]: QueryParam.Claims,
  [Tab.Payment]: QueryParam.Payments,
};

@Component({
  selector: 'app-claim-management-view',
  templateUrl: './claim-management-view.component.html',
  styleUrls: ['../../../../../../styles/global/_management-styles.scss']
})
export class ClaimManagementViewComponent implements OnInit, OnDestroy {
  readonly destroyed$ = new Subject();
  readonly TabLabel = TabLabel;

  activeTabName = 'Cases';
  activeTabIndex = 0;
  showSubmitAuth: boolean;
  showSubmitClaim: boolean;
  showCases: boolean;
  showPayments: boolean;
  private currentTab: string;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private environmentService: EnvironmentService,
    private tabSelectionService: TabSelectionService,
    private userAuthorisationService: UserAuthorisationService
  ) {

    this.showSubmitClaim = this.environmentService.isAllowedToSubmitClaimForNormalPortal();
    this.showSubmitAuth = this.environmentService.isAllowedToSubmitAuthForNormalPortal();
    this.showCases = this.environmentService.isCasesFeatureEnabled();
    this.showPayments = this.environmentService.isPaymentsFeatureEnabled();

    if (!this.showCases) {
      this.activeTabIndex = Tab.Claim;
      this.activeTabName = 'Transactions';
    }
  }

  get isAuthorised(): boolean {
    return this.userAuthorisationService.hasRoleClaimsAssessor();
  }

  ngOnInit(): void {
    this.tabSelectionService.currentTab$AsObservable
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((currentTab: string) => {
      this.currentTab = currentTab;
      this.selectTab(currentTab);
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  selectTab(tabName: string) {
    if (tabName === QueryParam.Cases && !this.showCases) {
      this.redirectToTransactions();
    }
    else if (tabName === QueryParam.Payments && !this.showPayments) {
      this.redirectToTransactions();
    }
    else if (tabName === QueryParam.Cases) {
      this.activeTabIndex = Tab.Case;
      this.activeTabName = 'Cases';
    }
    else if (tabName === QueryParam.Claims) {
      this.activeTabIndex = Tab.Claim;
      this.activeTabName = 'Claims';
    }
    else if (tabName === QueryParam.Payments) {
      this.activeTabIndex = Tab.Payment;
      this.activeTabName = 'Payments';
    }
  }

  openFlowDiagram() {
    this.dialog.open(GenericImageDialogComponent, {
      height: '90vh',
      data: {heading: 'Claim Flow', src: '/assets/claim-flow-diagram.png'}
    });
  }

  onTabSelectionChanged($event: MatTabChangeEvent) {
    this.router.navigate(['/claim-management'], {
      queryParams: {tab: TabQueryParamByIndexNo[$event.index]},
    });
  }

  private redirectToTransactions(): void {
    this.router.navigate(['/claim-management'], {
      queryParams: {tab: QueryParam.Claims},
      replaceUrl: true
    });
  }
}
